import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useAddAssets = () =>
  useMutation({
    mutationFn: (data) =>
      client("resources/assets/add", {
        data,
        successMessage: "Asset has been added successfully",
      }),
  });

export const useGetAssets = () =>
  useMutation({
    mutationFn: (data) =>
      client("resources/assets", {
        data,
      }),
  });
export const useDeleteAssets = () =>
  useMutation({
    mutationFn: (id) =>
      client(`resources/assets/${id}`, {
        customConfig: {
          method: "delete",
          successMessage: "Asset has been deleted successfully",
        },
      }),
  });
